module.exports = __webpack_public_path__ + "media/fonts/icomoon/fonts/icomoon-9683295bbad77cde4c05b6f3dea6f681.ttf";